module.exports = __webpack_public_path__ + "app/principal/division-details-1B8iajQf.html";